import { FeatureFlag } from '@revelio/core';

import { useUnleashFlag } from '../../shared/unleash-flags/use-unleash-flag';

/**
 * Global AI assistant (FAB + drawer, bridge, chart previews, assistant
 * homepage, tour closing step) renders for every user now that the themed
 * appearance is the only appearance — unless the `DisableAIAssistant` kill
 * switch is set for them (see the flag's own note for why its polarity is
 * inverted). Every assistant surface reads this hook, so the flag removes the
 * whole surface — no `turn-step` request is ever issued.
 *
 * This is the ONLY consumer of the kill switch: the legacy CustomDash AI
 * drawer was deleted alongside it, so nothing else in the dashboard can reach
 * an LLM chat.
 */
export function useGlobalAIAssistantFeatureEnabled(): boolean {
  const assistantDisabled = useUnleashFlag(FeatureFlag.DisableAIAssistant);
  return !assistantDisabled;
}
